import type { DeepPartial } from '@luna/utils-ts';

import type { AddressBook } from './AddressBook';

export const AT: DeepPartial<AddressBook> = {
    contactDetails: {
        fetchTaxAuthorityName: true,
    },
    cacheDuration: {
        contact: 10000,
        template: 10000,
        templates: 10000,
        search: 5000,
    },
    cacheDurationV2: {
        search: 5000,
    },
};
